import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { ThemeProvider } from './contexts/ThemeContext'
import ProtectedRoute from './components/ProtectedRoute'
import Login from './pages/Login'
import AuthCallback from './pages/AuthCallback'
import LandingPage from './pages/LandingPage'
import TestCaseGenerator from './pages/TestCaseGenerator'
import OffersAudit from './pages/OffersAudit'
import RiskPrioritization from './pages/RiskPrioritization'
import TestCaseUpdate from './pages/TestCaseUpdate'
import RTAudit from './pages/RTAudit'
import Settings from './pages/Settings'
import FigmaCallback from './pages/FigmaCallback'
import JiraCallback from './pages/JiraCallback'


function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />

          {/* Protected routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <LandingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/test-case/*"
            element={
              <ProtectedRoute>
                <TestCaseGenerator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/offers-audit/*"
            element={
              <ProtectedRoute>
                <OffersAudit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/audit/:jobId"
            element={
              <ProtectedRoute>
                <OffersAudit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/risk-prioritization/*"
            element={
              <ProtectedRoute>
                <RiskPrioritization />
              </ProtectedRoute>
            }
          />
          <Route
            path="/test-case-updater/*"
            element={
              <ProtectedRoute>
                <TestCaseUpdate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/rt-audit/*"
            element={
              <ProtectedRoute>
                <RTAudit />
              </ProtectedRoute>
            }
          />

          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/figma/callback"
            element={
              <ProtectedRoute>
                <FigmaCallback />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/jira/callback"
            element={
              <ProtectedRoute>
                <JiraCallback />
              </ProtectedRoute>
            }
          />

          {/* Catch-all redirect */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
